"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sessions = void 0;
const sdk_1 = require("../sdk");
var Sessions;
(function (Sessions) {
    Sessions.list = (options) => {
        const url = '/sessions';
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    Sessions.create = (data) => {
        const url = `/sessions`;
        return sdk_1.SDK.axios.post(url, data);
    };
    Sessions.importCSV = (data, facilityId, accountId) => {
        let url = `/sessions/import-csv?facilityId=f:${facilityId}`;
        if (accountId) {
            url = `/sessions/import-csv?facilityId=f:${facilityId}&accountId=${accountId}`;
        }
        return sdk_1.SDK.axios.post(url, data);
    };
    Sessions.importCSVAppRules = (data, facilityId) => {
        const url = `/sessions/import-csv-apps?facilityId=f:${facilityId}`;
        return sdk_1.SDK.axios.post(url, data);
    };
    Sessions.get = (sessionId) => {
        const url = `/sessions/${sessionId}`;
        return sdk_1.SDK.axios.get(url);
    };
    Sessions.getProgress = (sessionId, options) => {
        const url = `/sessions/progress/${sessionId}`;
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    Sessions.listProgress = (options) => {
        const url = '/sessions/progress';
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    Sessions.lastAuditList = (options) => {
        const url = '/sessions/listAudit';
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
})(Sessions = exports.Sessions || (exports.Sessions = {}));
//# sourceMappingURL=sessions.js.map